import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Row, Col, Card, CardBody, CardTitle } from 'reactstrap';

import ModalCuotas from './ModalCuotas';
import ModalVentas from "../Escrituras/Modal";
import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable.js";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import { format } from '../../../functions/functions';

import api from "../../../api/api.js";

class Cobros extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    accessor: d => moment(d.fecha).format('DD/MM/YYYY'),
                    className: "text-center",
                    show: true,
                    width: 100,
                    filterable: false
                },
                {
                    Header: "Comprador/es",
                    id: "clientes",
                    accessor: d => d.clientes,
                    show: true,
                    filterable: false
                },
                {
                    Header: "Loteo",
                    id: "loteo",
                    lookup: "nombre__icontains",
                    accessor: d => d.loteo.nombre,
                    show: true,
                    filterable: false
                },
                {
                    Header: "Lote",
                    id: "lote_nombre",
                    accessor: "lote_nombre",
                    show: true,
                    filterable: false
                },
                {
                    Header: "Vendedor",
                    id: "vendedor_nombre",
                    accessor: "vendedor_nombre",
                    show: true,
                    filterable: false
                },
                {
                    Header: "Cuotas restantes",
                    id: "cuotasImpagas",
                    accessor: "cuotasImpagas",
                    show: true,
                    width: 150,
                    className: 'text-center',
                    filterable: false
                },
                {
                    Header: "Moneda",
                    id: "moneda",
                    accessor: "moneda",
                    show: false,
                    private: true,
                },
                {
                    Header: "Monto",
                    id: "monto_total_cuotas",
                    accessor: d => `${d.moneda.simbolo} ${format(d.monto_total_cuotas)}`,
                    className: 'text-right',
                    show: true,
                    filterable: false
                },
            ],
            compradores: '',
            loteo_id: null,
        };
    }

    render() {
        const { compradores, loteo_id } = this.state;

        let outerFilter = [];
        if (compradores) {
            outerFilter.push({
                id: 'clientes',
                value: compradores
            });
        }
        if (loteo_id) {
            outerFilter.push({
                id: 'loteo_id',
                value: {
                    lookup: 'exact',
                    input: loteo_id,
                }
            });
        }

        return (
            <Row className="m-0">
                <Col className="col-12 mt-2">
                    <Card body className="border-0 p-0 mb-3">
                        <CardTitle className="text-center py-2 mb-0 col-color">Selección</CardTitle>
                        <CardBody>
                            <Row>
                                <Col className="col-12 col-md-6">
                                    <ParadigmaLabeledInput
                                        label="Cliente"
                                        md={[3, 9]}
                                        value={compradores}
                                        onChange={e => this.setState({ compradores: e.target.value })}
                                    />
                                </Col>
                                <Col className="col-12 col-md-6">
                                    <ParadigmaLabeledInput
                                        label="Loteo"
                                        md={[3, 9]}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                //url={api.loteos.loteos}
                                                url={api.loteos.loteos_select}
                                                parameters={{
                                                    paginationEnabled:false,
                                                    sort:['nombre']
                                               }}
                                                value={loteo_id}
                                                onChange={data => this.setState(prevState => ({
                                                    loteo_id: data ? data.id : null
                                                }), this.fetch)}
                                            />
                                        }
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col className="col-12">
                    <ParadigmaTable
                        title={"Cobros"}
                        buttons={[
                            {
                                edit: true,
                                component: props => <ModalCuotas {...props} action="PAGAR" />,
                                permission: 'escrituras_escrituras_detail',
                            },
                            {
                                edit: true,
                                component: props => <ModalVentas {...props} action="CUOTAS" activeTab={2} />,
                                permission: 'escrituras_escrituras_view',
                            }
                        ]}
                        depth={2}
                        apiUrl={api.escrituras.escrituras}
                        columns={this.state.columns}
                        defaultPageSize={24}
                        outerFilter={[
                            {
                                id: 'estado',
                                value: 'F'
                            },
                            {
                                id: 'saldado',
                                value: {
                                    lookup: 'exact',
                                    input: 0
                                }
                            },
                            ...outerFilter,
                        ]}
                    />
                </Col>

            </Row>
        );
    }
}

export default Cobros;



// WEBPACK FOOTER //
// ./src/views/Escrituras/Cobros/Cobros.js